// New Advanced Geometric Sketches Data - Organized for Supabase Migration
// Table: new_sketches

export const NEW_SKETCHES_DATA = [
  {
    id: "circular-cone-3d-001",
    category_id: "3d-shapes",
    name: "Circular Cone",
    description: "3D circular cone with height (h), radius (r), and slant height (l)",
    coordinates: "Base center at origin, apex at height h, radius r from center",
    type: "3D",
    difficulty_level: "intermediate",
    tags: ["cone", "3d", "circular", "height", "radius", "slant"],
    default_params: {
      centerX: 200,
      centerY: 150,
      radius: 80,
      height: 120,
      showHeight: true,
      showRadius: true,
      showSlant: true,
      baseFill: "rgba(100,100,100,0.3)",
      sideFill: "rgba(150,150,150,0.4)",
      stroke: "black",
      strokeWidth: 2,
      heightColor: "red",
      radiusColor: "blue",
      slantColor: "green"
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 100, max: 300 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "radius", label: "Radius (r)", type: "number", min: 40, max: 120 },
      { name: "height", label: "Height (h)", type: "number", min: 60, max: 180 },
      { name: "showHeight", label: "Show Height Line", type: "checkbox" },
      { name: "showRadius", label: "Show Radius Line", type: "checkbox" },
      { name: "showSlant", label: "Show Slant Height", type: "checkbox" },
      { name: "baseFill", label: "Base Color", type: "color" },
      { name: "sideFill", label: "Side Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Edge Width", type: "number", min: 1, max: 5 },
      { name: "heightColor", label: "Height Line Color", type: "color" },
      { name: "radiusColor", label: "Radius Line Color", type: "color" },
      { name: "slantColor", label: "Slant Line Color", type: "color" }
    ],
    drag_points: ['apex', 'baseCenter'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "cuboid-diagonals-3d-001",
    category_id: "3d-geometry",
    name: "Cuboid with Diagonals",
    description: "3D rectangular prism with internal diagonal lines and labeled vertices A-H",
    coordinates: "8 vertices A-H, bottom face ABCD, top face EFGH with internal diagonals",
    type: "3D",
    difficulty_level: "advanced",
    tags: ["cuboid", "3d", "diagonals", "vertices", "wireframe"],
    default_params: {
      width: 120,
      height: 80,
      depth: 100,
      centerX: 200,
      centerY: 150,
      showVertices: true,
      showEdges: true,
      showDiagonals: true,
      showLabels: true,
      edgeColor: "black",
      diagonalColor: "blue",
      vertexColor: "red",
      strokeWidth: 2,
      hiddenLineStyle: "dashed"
    },
    parameter_config: [
      { name: "width", label: "Width", type: "number", min: 80, max: 160 },
      { name: "height", label: "Height", type: "number", min: 60, max: 120 },
      { name: "depth", label: "Depth", type: "number", min: 60, max: 140 },
      { name: "centerX", label: "Center X", type: "number", min: 150, max: 250 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "showVertices", label: "Show Vertices", type: "checkbox" },
      { name: "showEdges", label: "Show Edges", type: "checkbox" },
      { name: "showDiagonals", label: "Show Diagonals", type: "checkbox" },
      { name: "showLabels", label: "Show Labels", type: "checkbox" },
      { name: "edgeColor", label: "Edge Color", type: "color" },
      { name: "diagonalColor", label: "Diagonal Color", type: "color" },
      { name: "vertexColor", label: "Vertex Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 },
      { name: "hiddenLineStyle", label: "Hidden Line Style", type: "select", options: ["dashed", "dotted", "thin"] }
    ],
    drag_points: ['center'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "intersecting-planes-triangle-3d-001",
    category_id: "3d-geometry",
    name: "Intersecting Planes with Triangle",
    description: "3D intersecting planes π₁ and π₂ with triangular connection and angle θ",
    coordinates: "Planes π₁ (parallelogram), π₂ (triangle), points B, Q, A, P, R with angle θ",
    type: "3D",
    difficulty_level: "advanced",
    tags: ["planes", "intersection", "3d", "triangle", "angle", "geometry"],
    default_params: {
      plane1Width: 160,
      plane1Height: 100,
      plane2Width: 120,
      plane2Height: 80,
      centerX: 200,
      centerY: 150,
      angle: 45,
      showAngle: true,
      showRightAngle: true,
      showPoints: true,
      plane1Fill: "rgba(100,150,255,0.3)",
      plane2Fill: "rgba(255,150,100,0.3)",
      triangleFill: "rgba(150,255,150,0.4)",
      stroke: "black",
      strokeWidth: 2,
      angleColor: "red",
      rightAngleColor: "blue"
    },
    parameter_config: [
      { name: "plane1Width", label: "Plane π₁ Width", type: "number", min: 120, max: 200 },
      { name: "plane1Height", label: "Plane π₁ Height", type: "number", min: 80, max: 140 },
      { name: "plane2Width", label: "Plane π₂ Width", type: "number", min: 100, max: 160 },
      { name: "plane2Height", label: "Plane π₂ Height", type: "number", min: 60, max: 120 },
      { name: "centerX", label: "Center X", type: "number", min: 150, max: 250 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "angle", label: "Angle θ (degrees)", type: "number", min: 15, max: 75 },
      { name: "showAngle", label: "Show Angle θ", type: "checkbox" },
      { name: "showRightAngle", label: "Show Right Angle", type: "checkbox" },
      { name: "showPoints", label: "Show Point Labels", type: "checkbox" },
      { name: "plane1Fill", label: "Plane π₁ Color", type: "color" },
      { name: "plane2Fill", label: "Plane π₂ Color", type: "color" },
      { name: "triangleFill", label: "Triangle Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 },
      { name: "angleColor", label: "Angle Color", type: "color" },
      { name: "rightAngleColor", label: "Right Angle Color", type: "color" }
    ],
    drag_points: ['center', 'plane1', 'plane2'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "sphere-cross-section-3d-001",
    category_id: "3d-shapes",
    name: "Sphere Cross-Section",
    description: "2D representation of 3D sphere with circular cross-section disk and radius r",
    coordinates: "Sphere outline, cross-section disk at center with radius r",
    type: "2D",
    difficulty_level: "intermediate",
    tags: ["sphere", "cross-section", "disk", "radius", "3d-representation"],
    default_params: {
      centerX: 200,
      centerY: 150,
      sphereRadius: 100,
      diskRadius: 60,
      diskOffsetY: 0,
      showSphere: true,
      showDisk: true,
      showRadius: true,
      sphereColor: "rgba(139,69,19,0.8)",
      diskColor: "rgba(128,128,128,0.6)",
      radiusColor: "red",
      stroke: "black",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 100, max: 300 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "sphereRadius", label: "Sphere Radius", type: "number", min: 60, max: 140 },
      { name: "diskRadius", label: "Disk Radius (r)", type: "number", min: 30, max: 100 },
      { name: "diskOffsetY", label: "Disk Y Offset", type: "number", min: -40, max: 40 },
      { name: "showSphere", label: "Show Sphere", type: "checkbox" },
      { name: "showDisk", label: "Show Cross-Section", type: "checkbox" },
      { name: "showRadius", label: "Show Radius Line", type: "checkbox" },
      { name: "sphereColor", label: "Sphere Color", type: "color" },
      { name: "diskColor", label: "Disk Color", type: "color" },
      { name: "radiusColor", label: "Radius Line Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    drag_points: ['center', 'disk'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  },
  {
    id: "point-to-plane-geometry-3d-001",
    category_id: "3d-geometry",
    name: "Point to Plane Geometry",
    description: "3D point P above plane π with orthogonal projection N and right triangle PQN",
    coordinates: "Point P above plane π, projection N, point Q on plane, right angle at N, angle θ at Q",
    type: "3D",
    difficulty_level: "advanced",
    tags: ["3d", "projection", "right-triangle", "plane", "angle", "orthogonal"],
    default_params: {
      centerX: 200,
      centerY: 150,
      planeWidth: 140,
      planeHeight: 100,
      pointPHeight: 80,
      pointQOffset: 40,
      showPlane: true,
      showProjection: true,
      showTriangle: true,
      showRightAngle: true,
      showAngle: true,
      planeFill: "rgba(200,200,200,0.4)",
      projectionColor: "red",
      triangleColor: "blue",
      rightAngleColor: "green",
      angleColor: "orange",
      stroke: "black",
      strokeWidth: 2
    },
    parameter_config: [
      { name: "centerX", label: "Center X", type: "number", min: 150, max: 250 },
      { name: "centerY", label: "Center Y", type: "number", min: 100, max: 200 },
      { name: "planeWidth", label: "Plane Width", type: "number", min: 100, max: 180 },
      { name: "planeHeight", label: "Plane Height", type: "number", min: 80, max: 140 },
      { name: "pointPHeight", label: "Point P Height", type: "number", min: 50, max: 120 },
      { name: "pointQOffset", label: "Point Q Offset", type: "number", min: 20, max: 60 },
      { name: "showPlane", label: "Show Plane π", type: "checkbox" },
      { name: "showProjection", label: "Show Projection Line", type: "checkbox" },
      { name: "showTriangle", label: "Show Triangle", type: "checkbox" },
      { name: "showRightAngle", label: "Show Right Angle", type: "checkbox" },
      { name: "showAngle", label: "Show Angle θ", type: "checkbox" },
      { name: "planeFill", label: "Plane Color", type: "color" },
      { name: "projectionColor", label: "Projection Color", type: "color" },
      { name: "triangleColor", label: "Triangle Color", type: "color" },
      { name: "rightAngleColor", label: "Right Angle Color", type: "color" },
      { name: "angleColor", label: "Angle θ Color", type: "color" },
      { name: "stroke", label: "Edge Color", type: "color" },
      { name: "strokeWidth", label: "Line Width", type: "number", min: 1, max: 4 }
    ],
    drag_points: ['pointP', 'pointQ', 'center'],
    is_active: true,
    created_at: "2024-01-01T00:00:00Z",
    updated_at: "2024-01-01T00:00:00Z"
  }
];

export const getNewSketchById = (id) => {
  return NEW_SKETCHES_DATA.find(sketch => sketch.id === id);
};

export const getNewSketchesByCategory = (categoryId) => {
  return NEW_SKETCHES_DATA.filter(sketch => sketch.category_id === categoryId);
};
